import {ReactNode} from 'react';

/**
 * Walks toast `content` (a string, JSX, or nested fragments) and returns its
 * text leaves in order, untouched. Only descends into elements that pass
 * their own `children` through — a custom component taking other props
 * (e.g. `headline`) yields nothing.
 */
export const getTextLeaves = (content: ReactNode): Array<string | number> => {
  const leaves: Array<string | number> = [];

  function traverse(node: ReactNode) {
    if (typeof node === 'string' || typeof node === 'number') {
      leaves.push(node);
    } else if (Array.isArray(node)) {
      node.forEach(traverse);
    } else if (node && typeof node === 'object' && 'props' in node) {
      traverse((node as {props: {children?: ReactNode}}).props.children);
    }
  }

  traverse(content);
  return leaves;
};
